import React, { PureComponent } from "react";
import { Menu } from "element-react";

import { withRouter, Link } from "react-router-dom";
require("./index.scss");

class NavMenu extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {

    };

  }

  componentWillMount() {

  }

  render() {
    const nav = this.props.nav;
    // let { defaultActive, showNav } = this.state;
    return (          
          <div className="nav">
            <div className="nav-container">
              <Menu className="el-menu-demo" mode="horizontal">
                {nav && nav.map((item, index) => {
                  return (
                    <Menu.Item index={item.url} key={index}>
                      <Link to={item.url}>
                        {item.name}
                      </Link>
                    </Menu.Item>
                  )
                })}
              </Menu>
            </div>
          </div> 
    );
  }
}


export default NavMenu